<script setup>
import { computed, defineAsyncComponent, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
/***/
import { useApplicationStore } from '@stores/application';
import { useAuthReturnTaskStore } from '@stores/auth/returnTask';
/***/
import Str from '@classes/Str';

// Composants
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const Wrapper = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Dashboard/Wrapper'));

// Route
const route = useRoute();

// I18n
const { t } = useI18n();

// Stores
const applicationStore = useApplicationStore();
const returnTaskStore = useAuthReturnTaskStore();

// Application courante
const currentApplication = computed(() => applicationStore.getCurrent);

// Retourne la tâche correspondant à l'identifiant public dans l'URL
const fromTaskPublicId = route.query['from-task-return'];
const fromTaskReturn = computed(() => {
    if(! fromTaskPublicId) {
        return null;
    }
    return returnTaskStore.getReturnTaskByPublicId(fromTaskPublicId);
});

// Retourne le message lié à la gestion de la tâche
const taskReturnMessage = computed(() => {
    if(fromTaskReturn.value === null) {
        return null;
    }
    const allowedStatuses = [ 'PLANNED', 'VALIDATED', 'PUBLICATION_WAITING', 'COMPLETED', 'PUBLISHED' ];

    if(allowedStatuses.indexOf(fromTaskReturn.value.status) === -1) {
        return null;
    }

    const camelCaseStatus = new Str(fromTaskReturn.value.status.toLowerCase()).toCamelCase('_');

    return t('page.home.return.' + camelCaseStatus, {
        task: fromTaskReturn.value.title
    });
});

onMounted(() => {
    // Titre de la page
    document.title = currentApplication.value.name;
});
</script>

<template>
    <layout>
        <wrapper>
            <template v-slot:messages>
                <p v-if="taskReturnMessage" class="generic-message generic-message-success">
                    {{ taskReturnMessage }}
                </p>
            </template>
        </wrapper>
    </layout>
</template>
